/* eslint-disable import/max-dependencies */
import system from './system';
export { aliases } from './config';
export { default as getAlignSelf } from './getAlignSelf';
export { default as getBorderRadius } from './getBorderRadius';
export { default as getColor, getTextColor } from './getColor';
export { default as getDecoration } from './getDecoration';
export { default as getDisplay } from './getDisplay';
export { default as getFloat } from './getFloat';
export { default as getFontFamily } from './getFontFamily';
export { default as getFontStyle } from './getFontStyle';
export { default as getFlex } from './getFlex';
export { default as getFontWeight } from './getFontWeight';
export { default as getHeight, getMaxHeight } from './getHeight';
export { default as getLogo } from './getLogo';
export { default as getMargin } from './getMargin';
export { default as getPadding } from './getPadding';
export { default as getPosition } from './getPosition';
export { default as getSystem } from './getSystem';
export { default as getTextAlign } from './getTextAlign';
export { default as getTextTransform } from './getTextTransform';
export { default as getWidth, getMaxWidth } from './getWidth';
export { default as getZIndex } from './getZIndex';
export { getTop, getRight, getBottom, getLeft } from './getPositioning';
export default system;